
/* injects from baggage-loader */
require('./style.styl');

import React, {Component} from 'react'
import * as _ from 'lodash'
import {connect} from 'react-redux'
import {getCurrentSite} from 'redux/modules/currentUser/selectors'
import {
  getOnboardStatus,
  initState
} from 'redux/modules/onboard/actions'
import PropTypes from 'prop-types'

class OnboardingProgress extends Component {
  static propTypes = {
    isInited: PropTypes.bool,
    isOnboardSuccess: PropTypes.bool,
    isLoadedStep: PropTypes.bool,
    steps: PropTypes.array,
    getOnboardStatus: PropTypes.func,
    initState: PropTypes.func
  }

  componentDidMount() {
    const {isInited, isOnboardSuccess} = this.props

    if (!isInited) {
      this.props.initState()
    }

    if (!isOnboardSuccess) {
      this.props.getOnboardStatus()
    }
  }

  render() {
    const {steps, isLoadedStep, isInited, isOnboardSuccess} = this.props

    if (!isInited || !isLoadedStep || isOnboardSuccess) {
      return null
    }

    const completed = _.filter(steps, {status: 'completed'}).length
    const progress = Number(((completed * 100) / steps.length).toFixed(1))
    let progressState = ''

    if (progress > 87.5) {
      progressState = 'progress-100'
    } else if (progress >= 50) {
      progressState = 'progress-50'
    }

    return (
      <div className='onboarding-progress-container'>
        <span className={`progress-label ${progressState}`}>
          {progress}% onboarding progress
        </span>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    steps: state.onboard.steps,
    isInited: state.onboard.isInited,
    isOnboardSuccess: state.onboard.isOnboardSuccess,
    isLoadedStep: state.onboard.isLoadedStep,
    currentSite: getCurrentSite(state)
  }
}

export default connect(mapStateToProps, {
  getOnboardStatus,
  initState
})(OnboardingProgress)



// WEBPACK FOOTER //
// ./client/components/OnboardingWizard/OnboardingProgress/index.js